<unit>{{symbol | lang}}/{{name | lang}}</unit>
